module.exports = __webpack_public_path__ + "img/demo3-empview-phone.573306fd.png";